import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useApp } from "../../common/contexts/AppContext";
import BaseContainerWrapper from "../../common/components/BaseContainerWrapper";
import useIncidents from "../../common/hooks/pages/useIncidents";
import { useMutation } from "react-query";
import { usePopup } from "../../common/contexts/PopupContext";
import Updates from "../maintenance/Updates";
import Automation from "../maintenance/Automation";
import Postmortem from "../maintenance/Postmortem";

function MaintenanceContainer() {
  const { isOwner } = useApp();
  const { id } = useParams();
  const [openTab, setOpenTab] = useState(1);
  const { getMaintenance } = useIncidents();
  const { toast } = usePopup();

  const {
    data: maintenanceDataResponse,
    isLoading: isGetting,
    mutate: getMaintenanceMutate,
  } = useMutation({
    mutationFn: getMaintenance,
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while getting Maintenance!";
      toast(message, "error");
    },
  });

  useEffect(() => {
    if (id) {
      getMaintenanceMutate(id);
    }
  }, [id]);

  const maintenanceData = maintenanceDataResponse?.data?.maintenance || {};

  return (
    <BaseContainerWrapper>
      <div className="flex justify-between items-center pb-8 border-b">
        <div className="text-2xl font-bold">{maintenanceData.name}</div>
      </div>

      <div className="flex flex-wrap">
        <div className="w-full">
          <ul
            className="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row"
            role="tablist"
          >
            <li className="-mb-px mr-2 last:mr-0 flex-auto text-center">
              <a
                className={
                  "text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal " +
                  (openTab === 1
                    ? "text-green bg-" + "-600"
                    : "text-" + "-600 bg-white")
                }
                onClick={(e) => {
                  e.preventDefault();
                  setOpenTab(1);
                }}
                data-toggle="tab"
                href="#link1"
                role="tablist"
              >
                <i className="fas fa-space-shuttle text-base mr-1"></i>
                Maintenance updates
              </a>
            </li>
            <li className="-mb-px mr-2 last:mr-0 flex-auto text-center">
              <a
                className={
                  "text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal " +
                  (openTab === 2
                    ? "text-green bg-" + "-600"
                    : "text-" + "-600 bg-white")
                }
                onClick={(e) => {
                  e.preventDefault();
                  setOpenTab(2);
                }}
                data-toggle="tab"
                href="#link2"
                role="tablist"
              >
                <i className="fas fa-docs text-base mr-1"></i> Schedule &
                Automation
              </a>
            </li>
            {/* <li className="-mb-px mr-2 last:mr-0 flex-auto text-center">
              <a
                className={
                  "text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal " +
                  (openTab === 3
                    ? "text-green bg-" + "-600"
                    : "text-" + "-600 bg-white")
                }
                onClick={(e) => {
                  e.preventDefault();
                  setOpenTab(3);
                }}
                data-toggle="tab"
                href="#link3"
                role="tablist"
              >
                <i className="fas fa-docs text-base mr-1"></i> Postmortem
              </a>
            </li> */}
          </ul>
          <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 rounded">
            <div className="px-4 py-5 flex-auto">
              <div className="tab-content tab-space">
                <div className={openTab === 1 ? "block" : "hidden"} id="link1">
                  <Updates maintenanceData={maintenanceData} />
                </div>
                <div className={openTab === 2 ? "block" : "hidden"} id="link2">
                  <Automation maintenanceData={maintenanceData} />
                </div>
                {/* <div className={openTab === 3 ? "block" : "hidden"} id="link3">
                  <Postmortem />
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </BaseContainerWrapper>
  );
}

export default MaintenanceContainer;
